import {
  GROUPING_TYPES,
  TEAM_TYPES
} from "rivals/components/pages/Teams/types";

const ITEMS = {
  [TEAM_TYPES.COLLEGES]: [
    { key: GROUPING_TYPES.BY_CONFERENCE, title: "By Conference" },
    { key: GROUPING_TYPES.ALPHABETICALLY, title: "Alphabetically" }
  ],
  [TEAM_TYPES.HIGH_SCHOOLS]: [
    { key: GROUPING_TYPES.BY_REGION, title: "By Region" },
    { key: GROUPING_TYPES.ALPHABETICALLY, title: "Alphabetically" }
  ]
};

export default {
  toggleItems: ITEMS
};
